import { AVALIACAO_RESPOSTA_TIPO } from '../enums';

const RESPOSTAS_POR_QUESTAO_TIPO = {
  multipla_escolha_unica: ['Opcao 1', 'Opcao 2'],
  multipla_escolha_multipla: ['Opcao 1', 'Opcao 2', 'Opcao 3'],
  escala_linear: [1, 2, 3, 4, 5],
  likert: ['Discordo totalmente', 'Discordo', 'Neutro', 'Concordo', 'Concordo totalmente'],
  dicotomica: ['Sim', 'Nao'],
  data: ['AAAA-MM-DD'],
  numero: ['0']
};

const AVALIACAO_QUESTOES_RESPOSTAS = Object.entries(AVALIACAO_RESPOSTA_TIPO).reduce(
  (acc, [respostaTipoId, respostaTipo]) => {
    const { avaliacao_questao_tipo_id: questaoTipoId } = respostaTipo;

    acc[respostaTipoId] = {
      ...respostaTipo,
      respostas: RESPOSTAS_POR_QUESTAO_TIPO[questaoTipoId] || []
    };

    return acc;
  },
  {}
);

export default AVALIACAO_QUESTOES_RESPOSTAS;
